/* RPBA cart drawer - diagnostic overlay. 24 Aug 2026 (rev 2).
   Renders NOTHING unless the URL contains cartdebug=1.

   Exists because the drawer is fine on iPhone but sticky on an Oppo Find X8,
   and neither can be reproduced from a desktop browser or a sandbox.

   Read it like this:
     coarse:false   -> @media (pointer: coarse) is NOT matching, so the theme's
                       entire mobile drawer is switched off.
     SCROLLER '<<'  -> which element is really scrolling. On a phone it must be
                       mini-content. prod or product-cart means the desktop
                       architecture is running on a phone.
     CTA            -> sticky (correct) or static (sticky bar lost).
     locked         -> whether the body scroll lock engaged.
     touch ta:      -> the EFFECTIVE touch-action where your thumb landed, i.e.
                       the intersection down the ancestor chain. If it says
                       pan-x, a vertical drag from there is not allowed to
                       scroll anything - that is the sticky feel. Should read
                       'pan-x pan-y' on the add-on cards and 'auto' elsewhere. */
(function () {
  'use strict';
  if (!/[?&]cartdebug=1/.test(location.search)) return;

  var panel = document.createElement('div');
  panel.style.cssText = 'position:fixed;left:0;top:0;z-index:2147483647;' +
    'background:rgba(0,0,0,.88);color:#6f6;font:10px/1.35 ui-monospace,Menlo,monospace;' +
    'padding:5px 7px;max-width:100%;pointer-events:none;white-space:pre';

  var lastTouch = '-';
  var lastTA = '-';

  function effectiveTouchAction(el) {
    var allowed = ['pan-x', 'pan-y'];
    var n = el, seen = [];
    while (n && n.nodeType === 1) {
      var ta = getComputedStyle(n).touchAction;
      if (ta && ta !== 'auto' && ta !== 'manipulation') seen.push(ta);
      n = n.parentElement;
    }
    if (!seen.length) return 'auto';
    for (var i = 0; i < seen.length; i++) {
      var s = seen[i];
      if (s === 'none') return 'none';
      allowed = allowed.filter(function (a) { return s.indexOf(a) !== -1; });
    }
    return allowed.length ? allowed.join(' ') : 'NONE (conflict: ' + seen.join(' > ') + ')';
  }

  document.addEventListener('touchstart', function (e) {
    var t = e.target;
    var c = (t.className || '').toString().trim().split(/\s+/).slice(0, 2).join('.');
    lastTouch = c || t.tagName || '?';
    try { lastTA = effectiveTouchAction(t); } catch (err) { lastTA = 'err'; }
  }, { passive: true, capture: true });

  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }

  function scrollerLine(mc) {
    var names = ['mini-content', 'mini-cart-bottom', 'prod', 'product-cart'];
    var out = [];
    for (var i = 0; i < names.length; i++) {
      var el = mc.querySelector('.' + names[i]);
      if (!el) { out.push(names[i] + ': -'); continue; }
      var oy = getComputedStyle(el).overflowY;
      var max = el.scrollHeight - el.clientHeight;
      var flag = (max > 2 && (oy === 'auto' || oy === 'scroll')) ? ' <<' : '';
      out.push(names[i] + ': ' + oy.slice(0, 4) + ' ' + el.scrollTop + '/' + max + flag);
    }
    return out.join('\n');
  }

  function attach() {
    document.body.appendChild(panel);
    setInterval(function () {
      var mc = document.querySelector('.minicart');
      if (!mc) { panel.textContent = 'no .minicart yet'; return; }
      var ac = mc.querySelector('.action-checkout');
      panel.textContent =
        'coarse:' + mq('(pointer: coarse)') +
          ' anyCoarse:' + mq('(any-pointer: coarse)') +
          ' hover:' + mq('(hover: hover)') + '\n' +
        'w:' + window.innerWidth + ' h:' + window.innerHeight +
          ' dpr:' + (window.devicePixelRatio || 1) + '\n' +
        'open:' + mc.classList.contains('active') +
          ' rpba-mobile:' + mc.classList.contains('rpba-mobile') +
          ' locked:' + (document.body.style.position === 'fixed') + '\n' +
        'drawerH:' + Math.round(mc.getBoundingClientRect().height) +
          ' CTA:' + (ac ? getComputedStyle(ac).position : '-') + '\n' +
        scrollerLine(mc) + '\n' +
        'winY:' + Math.round(window.pageYOffset) + '\n' +
        'touch: ' + lastTouch + '\n' +
        'touch ta: ' + lastTA;
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
